module.exports = __webpack_public_path__ + "img/si.86f421da.svg";